import * as React from "react";
import styled from "styled-components";
const isNullOrEmpty = (s) => s === null || s === void 0 || s.trim() === "";
const Message = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const MessageCell = ({ value }) => isNullOrEmpty(value) ? /* @__PURE__ */ React.createElement("i", null, "No further message.") : /* @__PURE__ */ React.createElement(Message, null, value);
export default MessageCell;
